module.exports = __webpack_public_path__ + "static/media/Mothers Honor Roll.6bbc6257.png";